export function needsCallPreparation(mode: string, video: boolean): boolean {
  return mode === 'incoming' && video;
}
